/**
 * Reducer for tracking shop selection screen visit status
 * @param state Current state
 * @param action Action with visit status
 * @returns Updated state
 */
export const photoCaptureShopSelectionScreenVisitedReducer = (state, action) => {
    return Object.assign(Object.assign({}, state), { isShopSelectionScreenVisited: action.payload });
};
//# sourceMappingURL=photoCaptureShopSelectionScreenVisitedReducer.js.map